import React from 'react';
import RadioSelect from '../assets/images/RadioSelect.svg';

export default () => {
  return <img src={RadioSelect} alt="" />;
};
